import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetallePorCerealLinea5Actions'
import { TablaDetallePorCerealLinea5View } from '../components/TablaDetallePorCerealLinea5View'

class TablaDetallePorCerealLinea5 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetallePorCerealLinea5View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetallePorCerealLinea5)
